import React, {createContext, useMemo, useReducer} from 'react';
import {getAbsoluteSrc} from '../get-absolute-url.js';

export const durationReducer = (
	state,
	action
) => {
	switch (action.type) {
		case 'got-duration':
			return {
				...state,
				[getAbsoluteSrc(action.src)]: action.durationInSeconds,
			};
		default:
			return state;
	}
};

export const DurationsContext = createContext({
	durations: {},
	setDurations: () => {
		// throw new Error('context missing');
	},
});

export const DurationsContextProvider = ({children}) => {
	const [durations, setDurations] = useReducer(durationReducer, {});

	const value = useMemo(() => {
		return {
			durations,
			setDurations,
		};
	}, [durations]);

	return (
		<DurationsContext.Provider value={value}>
			{children}
		</DurationsContext.Provider>
	);
};
